import { Component, Input, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'aoe-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Input()
  title?: string;

  @Input()
  subTitle?: string | null;

  @Input()
  backgroundImage!: SafeUrl;

  @Input()
  color?: string;

  constructor() { }

  ngOnInit(): void {        
  }

  get picture(): string {
    return `url(${this.backgroundImage})`
  }

  get colorValue(): string {
    return this.color ?? 'inherit';
  }

}
